// @flow
import { isEmpty } from 'lodash';

export const isAppPageAvailable = (app: *) => {
  return !isEmpty(app);
};
